import React from "react";
import "./Peace_Of_Mind.css";
import Common_Back_Header from "../../../common_components/common_back_btn/Common_Back_Btn";
import Common_Title from "../../../common_components/common_title/Common_Title";

const Peace_Of_Mind = () => {
  return (
    <section className="Peace_Of_Mind City_Guard">
      <div className="container">
        <Common_Back_Header backNavigation={-1} />

        <Common_Title
          title={"PEACE OF MIND GUARANTEED"}
          subtitle={
            "At Majesty, we are redefining excellence with our exclusive “Peace of Mind Guaranteed” plan. This initiative is designed to strip away the stress of mattress shopping, replacing it with a seamless, premium experience built on a foundation of integrity and quality."
          }
        />

        <div className="main_content_div">
          <div className="big_img_section">

            <div className="big_img_holder">
              <div className="innner_img_holder">
                <img
                  src="/assets/images/hospitality/peace_of_mind/big_img.png"
                  className="big_img"
                />
              </div>

              <div className="content_div">
                <img
                  src="/assets/images/hospitality/peace_of_mind/quote.png"
                  className="quote_img"
                />

                <div className="innner_text">
                  Because we spend one-third of our lives asleep,<br/> sleep quality
                  is a vital factor in our overall well-being.
                </div>
              </div>
            </div>

            <p className="below_text">
              Our commitment to you is anchored by three core pillars:<br/> A promise
              of unrivaled product quality, a dedication to comprehensive
              customer support at every stage, and the exclusive use of
              rigorously tested, certified materials.
            </p>
          </div>

          <div className="common_gray_div">
            <p className="common_section_title">The Majesty Advantage</p>
            <p className="normal_text">
              By choosing the “Peace of Mind Guarantee,” you gain direct access
              to our most advanced sleep innovations:
            </p>

            <p className="p_title remove_space">Aero Sleep Technology:</p>
            <p className="p_text bottom_space">
              Say goodbye to restless, overheated nights. Majesty mattresses
              feature an open-cell HR foam structure that actively wicks away
              heat and moisture, maintaining the perfect micro-climate for
              uninterrupted sleep.
            </p>

            <p className="p_title remove_space">Certiguard Protection:</p>
            <p className="p_text bottom_space">
              Your health is our priority. Our Certiguard process ensures every
              mattress is free from harsh chemicals and unpleasant odors. Each
              product undergoes stringent lab testing to guarantee safety and
              purity before it ever reaches your home.
            </p>

            <p className="p_title remove_space"> Elite Customer Care:</p>
            <p className="p_text bottom_space">
              Our award-winning support team and certified sleep technicians are
              with you from day one. Whether you need expert guidance on
              choosing the right model or assistance in registering your
              warranty, we provide a white-glove service experience that lasts a
              lifetime.
            </p>
          </div>

          <div className="common_gray_div white_div">
            <p className="common_section_title">Why it Matters</p>
            <p className="normal_text">
              We don’t just sell mattresses; we manage your sleep health. The
              Majesty plan ensures that your investment is protected by the
              highest ethical standards and the latest scientific advancements
              in comfort.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Peace_Of_Mind;
